export default "// TODO when moving filter categories in home\n"